import { render, staticRenderFns } from "./FooterICP.vue?vue&type=template&id=687ef1b8&scoped=true&"
import script from "./FooterICP.vue?vue&type=script&lang=js&"
export * from "./FooterICP.vue?vue&type=script&lang=js&"
import style0 from "./FooterICP.vue?vue&type=style&index=0&id=687ef1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687ef1b8",
  null
  
)

export default component.exports